import { Component, OnInit, inject } from '@angular/core';
import { SecondaryButtonComponent } from '../../../../../shared/components/secondary-button/secondary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { HrisIntegrationDataService } from '../../services/hris-integration-data.service';

@Component({
  selector: 'app-hris-integration-setup-card',
  imports: [SecondaryButtonComponent, TranslocoPipe],
  templateUrl: './hris-integration-setup-card.component.html',
})
export class HrisIntegrationSetupCardComponent implements OnInit {
  protected readonly hrisIntegrationDataService = inject(
    HrisIntegrationDataService,
  );

  async handleButtonClick() {
    await this.hrisIntegrationDataService.openHRISIntegrationDialog();
  }
  ngOnInit() {
    this.hrisIntegrationDataService.observeUrlAndSendIntegration();
  }
}
